import {useEffect, useRef, useState} from "react";

import {useUnlockChoiceExperiment} from "../../hooks/use_unlock_choice_experiment";
import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS} from "./unlock_choice_modal/UnlockChoiceStep";

interface IProps {
    onDecide: (isTreatment: boolean) => void;
}

export const RegistrationSignUpExperimentStep = (props: IProps) => {
    const {onDecide} = props;
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: true});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const hasDecidedRef = useRef(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isResolved) {
            hasDecidedRef.current = true;
            trackExposure();
            onDecide(isTreatment);
            return;
        }

        if (hasTimedOut) {
            hasDecidedRef.current = true;
            onDecide(false);
        }
    }, [isResolved, isTreatment, hasTimedOut]);

    return null;
};
import {useEffect, useRef, useState} from "react";

import {useUnlockChoiceExperiment} from "../../hooks/use_unlock_choice_experiment";
import {UNLOCK_CHOICE_DECISION_TIMEOUT_MS} from "./unlock_choice_modal/UnlockChoiceStep";

interface IProps {
    onDecide: (isTreatment: boolean) => void;
}

export const RegistrationSignUpExperimentStep = (props: IProps) => {
    const {onDecide} = props;
    const {isResolved, isTreatment, trackExposure} = useUnlockChoiceExperiment({isEnabled: true});
    const [hasTimedOut, setHasTimedOut] = useState(false);
    const hasDecidedRef = useRef(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => setHasTimedOut(true), UNLOCK_CHOICE_DECISION_TIMEOUT_MS);

        return () => clearTimeout(timeoutId);
    }, []);

    useEffect(() => {
        if (hasDecidedRef.current) {
            return;
        }

        if (isResolved) {
            hasDecidedRef.current = true;
            trackExposure();
            onDecide(isTreatment);
            return;
        }

        if (hasTimedOut) {
            hasDecidedRef.current = true;
            onDecide(false);
        }
    }, [isResolved, isTreatment, hasTimedOut]);

    return null;
};
